import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/logo/gordian_white.svg'


const _hoisted_1 = { class: "mx-auto px-8 sm:px-6 lg:px-16" }
const _hoisted_2 = { class: "flex items-center justify-between h-14" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-5",
    src: _imports_0,
    loading: "eager",
    alt: "Gordian Software logo"
  })
], -1)
const _hoisted_5 = { class: "hidden xl:block" }
const _hoisted_6 = { class: "ml-6 flex items-baseline space-x-1 text-gray-300" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Reports")
const _hoisted_8 = { class: "flex-1 flex justify-end ml-5" }
const _hoisted_9 = { class: "flex-1 items-center mr-3 hidden md:block relative" }
const _hoisted_10 = {
  key: 0,
  ref: "searchResultsRef",
  class: "w-full rounded shadow-md absolute top-10 bg-white overflow-hidden flex flex-col justify-center align-center"
}
const _hoisted_11 = {
  key: 0,
  class: "loader ease-linear rounded-full border-2 border-t-3 border-gray-200 h-4 w-4 m-3"
}
const _hoisted_12 = {
  key: 1,
  class: "text-red-300 py-2 px-3"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Trip:", -1)
const _hoisted_15 = { class: "text-gray-500" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2 ml-2" }, "Reservation ID:", -1)
const _hoisted_17 = { class: "text-gray-500" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Session:", -1)
const _hoisted_20 = { class: "text-gray-500" }
const _hoisted_21 = { class: "flex items-center w-60 md:w-40 xl:w-60 mr-4" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "ml-2 block truncate" }
const _hoisted_25 = { class: "px-1 text-xs font-semibold rounded border text-gray-400 border-gray-400 mr-0.5" }
const _hoisted_26 = { class: "ml-1 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "px-1 text-xs font-semibold rounded border bg-blue-100 text-blue-800 border-blue-800 mr-0.5" }
const _hoisted_29 = { class: "flex items-center h-full" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_31 = { class: "block px-4 py-2 text-sm text-gray-700 w-full text-center" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "-mr-2 ml-2 flex xl:hidden" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_36 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-2 text-gray-300" }
const _hoisted_37 = { class: "pt-4 pb-3 border-t border-gray-700" }
const _hoisted_38 = { class: "flex items-center pl-5" }
const _hoisted_39 = { class: "text-base font-medium leading-none text-white" }
const _hoisted_40 = { class: "mt-3 px-2 space-y-1" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "h-14 w-full" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Disclosure, {
      as: "nav",
      class: "bg-gray-900 fixed z-50 w-full"
    }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: item.href,
                      class: "hover:text-white px-2 py-2 rounded-md text-sm font-medium",
                      "active-class": "text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  (_ctx.showReports)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: "report",
                        to: "/report",
                        class: "hover:text-white px-2 py-2 rounded-md text-sm font-medium",
                        "active-class": "text-white"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  spellcheck: "false",
                  class: "form-input w-full py-2 px-3 rounded-lg bg-opacity-10 bg-white border-none focus:ring-0 focus:bg-opacity-90 transition-colors text-sm text-white focus:text-gray-700 placeholder-gray-400 placeholder-sm",
                  type: "text",
                  placeholder: "Find Trips and Sessions by ID or PNR",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                (_ctx.searchResults.length > 0 || _ctx.searchLoading || _ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.searchLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.error)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.error), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedTrips, (trip) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: trip.tripId,
                          class: "flex justify-start w-full align-center cursor-pointer hover:bg-gray-100 py-2 px-3",
                          onClick: ($event: any) => (_ctx.goToTrip(trip.tripId as string))
                        }, [
                          _hoisted_14,
                          _createElementVNode("p", _hoisted_15, _toDisplayString(trip.tripId), 1),
                          (trip.reservationId)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_16,
                                _createElementVNode("p", _hoisted_17, _toDisplayString(trip.reservationId), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_13))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedSessions, (session) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: session.id,
                          class: "flex justify-start w-full align-center cursor-pointer hover:bg-gray-100 py-2 px-3",
                          onClick: ($event: any) => (_ctx.goToSession(session.id as number))
                        }, [
                          _hoisted_19,
                          _createElementVNode("p", _hoisted_20, _toDisplayString(session.id), 1)
                        ], 8, _hoisted_18))
                      }), 128))
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Listbox, {
                  as: "div",
                  modelValue: _ctx.sharedState.integration,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sharedState.integration) = $event)),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_ListboxButton, { class: "form-input w-full bg-opacity-10 bg-white border-none rounded-lg pl-1 pr-2 py-2 text-left cursor-default focus:outline-none focus:ring-0 text-sm text-gray-400" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.sharedState.integration.type), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.sharedState.integration.displayName ||
                        _ctx.sharedState.integration.integrationName), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_26, [
                            _createVNode(_component_SelectorIcon, {
                              class: "h-5 w-5 text-gray-400",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "leave-active-class": "transition ease-in duration-100",
                        "leave-from-class": "opacity-100",
                        "leave-to-class": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.sharedState.integrations)
                            ? (_openBlock(), _createBlock(_component_ListboxOptions, {
                                key: 0,
                                class: "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-0 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedState.integrations, (integration) => {
                                    return (_openBlock(), _createBlock(_component_ListboxOption, {
                                      as: "template",
                                      key: integration.id,
                                      value: integration
                                    }, {
                                      default: _withCtx(({ active, selected }) => [
                                        _createElementVNode("li", {
                                          class: _normalizeClass([
                          active ? 'bg-gray-200' : 'text-gray-900',
                          'cursor-default select-none relative py-2 px-0.5 text-sm',
                        ])
                                        }, [
                                          _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass([
                              selected ? 'font-semibold' : 'font-normal',
                              'ml-3 block truncate',
                            ])
                                            }, [
                                              _createElementVNode("span", _hoisted_28, _toDisplayString(integration.type), 1),
                                              _createTextVNode(" " + _toDisplayString(integration.displayName ||
                              integration.integrationName), 1)
                                            ], 2)
                                          ]),
                                          selected
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass([
                            active ? 'text-white' : 'text-indigo-600',
                            'absolute inset-y-0 right-0 flex items-center pr-4',
                          ])
                                              }, [
                                                _createVNode(_component_CheckIcon, {
                                                  class: "h-5 w-5",
                                                  "aria-hidden": "true"
                                                })
                                              ], 2))
                                            : _createCommentVNode("", true)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_Menu, {
                as: "div",
                class: "ml-auto relative hidden xl:block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_MenuButton, { class: "max-w-xs bg-gray-800 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                      default: _withCtx(() => [
                        _hoisted_30,
                        _createVNode(_component_UserCircleIcon, {
                          class: "h-8 w-8 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-60 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuItem, { as: "div" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.user.email), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_MenuItem, { as: "div" }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                                class: "hover:bg-gray-100 block px-4 py-2 text-sm text-gray-700 w-full"
                              }, " Sign Out ")
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                            return (_openBlock(), _createBlock(_component_MenuItem, {
                              as: "div",
                              key: item.name
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  href: item.href,
                                  class: "hover:bg-gray-100 block px-4 py-2 text-sm text-gray-700 w-full"
                                }, [
                                  _createElementVNode("a", {
                                    href: item.href
                                  }, _toDisplayString(item.name), 9, _hoisted_33)
                                ], 8, _hoisted_32)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_DisclosureButton, { class: "bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  (!open)
                    ? (_openBlock(), _createBlock(_component_MenuIcon, {
                        key: 0,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(_component_XIcon, {
                        key: 1,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ]),
        _createVNode(_component_DisclosurePanel, { class: "xl:hidden" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.name,
                  to: item.href,
                  class: "hover:bg-gray-700 hover:text-white block px-2 py-2 rounded-md text-base font-medium",
                  "active-class": "bg-gray-700 text-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.user.email), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                      class: "block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
                    }, " Sign Out "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.name,
                    href: item.href,
                    class: "block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
                  }, _toDisplayString(item.name), 9, _hoisted_41))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_42
  ], 64))
}